import { UserChannelsAPIResponse } from './types';

export function mapDataToClient(userChannelsResponse: UserChannelsAPIResponse) {
    return userChannelsResponse.channels;
}
